import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { ProfileService } from '../profile/profile.service';
import { DOCUMENT } from '@angular/common';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'jfriedman-generate-brief',
  templateUrl: './generatebrief.component.html',
  styleUrls: ['generatebrief.component.scss']
})
export class JFriedmanGenerateBriefComponent implements OnInit, OnDestroy {
  public isAuthenticated: boolean = false;
  public q: string;
  public clientList: string[] = [];
  public client: string = '';
  public numResponses: number = 20;
  public numBullets: number = 5;
  //public templateId: FormControl = new FormControl('', Validators.required); 
  //public briefBody: FormControl = new FormControl('', Validators.required); 
  public templateId: string = '';
  public briefBody: string = '';
  public useAi: boolean = true;
  public templates: { id: string, name: string }[] = [];
  public busyLoading: boolean = false;
  public busyGenerate: boolean = false;
  public caseDetails: any = null;


  constructor(private authorizeService: AuthorizeService,
    private http: HttpClient, private router: Router, private route: ActivatedRoute,
    private profileSvc: ProfileService, private sanitizer: DomSanitizer,
    private authSvc: AuthorizeService, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) {

    const elm = this.document.getElementById("nav-menu");
    if (elm) this.renderer.addClass(elm, 'hideme');
    const elm2 = this.document.getElementById("app-footer");
    if (elm2) this.renderer.addClass(elm2, 'hideme');
  }

  public ngOnDestroy(): void {
    const elm = this.document.getElementById("nav-menu");
    if (elm) this.renderer.removeClass(elm, 'hideme');
    const elm2 = this.document.getElementById("app-footer");
    if (elm2) this.renderer.removeClass(elm2, 'hideme');
  }

  async ngOnInit(): Promise<void> {
    this.busyLoading = true;
    
    // Check for case details from session storage
    const storedCaseDetails = sessionStorage.getItem('caseDetails');
    if (storedCaseDetails) {
      try {
        this.caseDetails = JSON.parse(storedCaseDetails);
      } catch (e) {
        console.error('Error parsing stored case details:', e);
      }
    }
    
    var token = await this.authSvc.getToken();
    if (token.sub != "acfc2497-cb44-4394-b866-3f546b306ff6"
      && token.sub != "75188666-0c61-4d26-b4d1-d184befa3afb" // alec
      && token.sub != '074e9283-ff17-49c1-b6f8-787d11dad581'
      && token.sub != '75188666-0c61-4d26-b4d1-d184befa3afb'
      && token.sub != 'ff08b278-700d-4d51-a589-42034ab6c925') this.router.navigate(['/home']);

    this.http.get('/jfriedman/authstatus').subscribe(
      (resp: any) => {
        console.log('resp ', resp);
        // if not logged in, redirect to login
        if (!resp.isLoggedIn)
          this.router.navigate(['/jfriedman/login']);
        else {
          this.http.get('/jfriedman/documentList').subscribe(
            (resp: { id: string, name: string }[]) => {
              console.log('resp ', resp);
              this.templates = resp;
              this.busyLoading = false;
            },
            (err: any) => {
              console.error('documentList threw exception');
              this.busyLoading = false;

            });
        }
      },
      (err: any) => {
        console.error('login status threw exception');
        this.busyLoading = false;

      }
    )



  }

  safe(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  public briefLink: string = '';

  public generateDocument(evt: any) {
    this.busyGenerate = true;
    this.briefLink = '';

    const briefDto = {
      templateId: this.templateId,
      briefBody: this.briefBody,
      useAI: this.useAi
    };

    this.http.post('/jfriedman/generatedocument', briefDto).subscribe(
      (resp: any) => {
        console.log('resp ', resp);
        this.briefLink = resp.documentLink;
        this.busyGenerate = false;
      },
      (err: any) => {
        console.error('generateDocument threw exception');
        this.busyGenerate = false;

      }
    )
  }

}
